import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { usePriceCalculation } from "src/hooks/usePriceCalculation";
import { useGlobalStore, useInstallationStore } from "src/store";
import { useDiscountStore } from "src/store/discount";
import { extraDayPrice } from "src/utils/constants";
import { FormSchema } from "./formSchema";
import { formattedAmount } from "./helpers";

export type PriceTableSchema = {
  id: number;
  article: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  enabled: boolean;
  netPrice?: number;
};

export const useGeneratePriceTable = (
  form: UseFormReturn<FormSchema, unknown>
) => {
  const { installationDetails } = useInstallationStore();

  const {
    totalBasePrice,
    extraDays,
    totalExtraDaysPrice,
    totalTwoSideBlockingPrice,
    totalPermissionPrice,
    totalWithOutsideLiftPrice,
    discountAmount,
    grandTotal,
  } = usePriceCalculation(form);
  const { global } = useGlobalStore();

  const { t } = useTranslation();
  const { discountPercentage } = useDiscountStore();

  const cityLabel =
    (+grandTotal &&
      global.cities.find((city) => city.value === installationDetails.city?.id)
        ?.labelWithoutLowestPrice) ||
    "";

  return [
    {
      id: 1,
      article:
        "Halterverbotszone" +
        (cityLabel ? ", " + cityLabel : "") +
        ", Deutschland (1 Tag)",
      quantity: 1,
      unitPrice: totalBasePrice,
      totalPrice: totalBasePrice,
      enabled: true,
    },
    {
      id: 2,
      article: t("charges:closureForFewDays"),
      quantity: extraDays,
      unitPrice: extraDayPrice,
      totalPrice: totalExtraDaysPrice,
      enabled: !!extraDays,
    },
    {
      id: 3,
      article: t("charges:twoSiteBlock"),
      quantity: 1,
      unitPrice: totalTwoSideBlockingPrice,
      totalPrice: totalTwoSideBlockingPrice,
      enabled: installationDetails.twoSiteBlock,
    },
    {
      id: 4,
      article: t("charges:withOutsideLift"),
      quantity: 1,
      unitPrice: totalWithOutsideLiftPrice,
      totalPrice: totalWithOutsideLiftPrice,
      enabled: installationDetails.withOutsideLift,
    },
    {
      id: 5,
      article: `${t("charges:discount")} (${discountPercentage}%)`,
      quantity: 0,
      unitPrice: 0,
      totalPrice: -discountAmount,
      enabled: !!discountAmount,
    },
    {
      id: 6,
      article: t("charges:withPermission"),
      quantity: 1,
      unitPrice: totalPermissionPrice,
      totalPrice: totalPermissionPrice,
      enabled: installationDetails.withPermission,
    },
    {
      id: 8,
      article: `${t("charges:total")} ${t("charges:include")} ${t(
        "charges:mwst"
      )} (${(grandTotal - grandTotal / 1.19).toFixed(2)}€)`,
      quantity: 0,
      unitPrice: 0,
      totalPrice: grandTotal,
      netPrice: formattedAmount(grandTotal / 1.19),
      enabled: true,
    },
  ];
};
